/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="69.92"
        height="95.58"
        viewBox="0 0 69.92 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M58.15 34.93a23.24 23.24 0 1 1-23.24-23.24 23.23 23.23 0 0 1 23.24 23.22"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M34.93 0A34.93 34.93 0 0 0 0 34.93a42.85 42.85 0 0 0 2.15 12.75c2.75 8.83 8 18.21 15 27.75a176.32 176.32 0 0 0 11.66 14.23l.92 1 .44.48.87.92.42.45.81.84.86.88 1 1a1.25 1.25 0 0 0 1.74 0l.58-.58.65-.65.64-.65.79-.85.85-.9.88-1 .91-1A178.47 178.47 0 0 0 52.8 75.33c7-9.54 12.21-18.92 15-27.75a43.17 43.17 0 0 0 2.12-12.75 34.93 34.93 0 0 0-35-34.87Zm0 2.5a32.43 32.43 0 0 1 32.43 32.43 40.83 40.83 0 0 1-2 12c-2.66 8.53-7.76 17.67-14.6 27a173 173 0 0 1-11.49 14l-.9 1-.44.48-.85.9-.82.86-.78.81-.55.56-.55-.56-.78-.81-.82-.86-.85-.9-.44-.48-.9-1a174.73 174.73 0 0 1-11.49-14c-6.84-9.32-11.94-18.43-14.6-27a40.51 40.51 0 0 1-2-12A32.42 32.42 0 0 1 34.92 2.49Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M31.31 25.02h6.31v-5.27h-6.31Zm6.52 20.92h3.41v3.62H28.62v-3.62h3.41V32.5h-3.41v-3.75h9.21Z"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'MapPinInformationalIcon';

export default Icon;
